// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3Zttg","buttons":"RemoveExpirationActionButtons_buttons__rOJsN"};